import React, {memo, useEffect, useRef, useState} from 'react';
import {Carousel, CarouselProps} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

interface Props extends Partial<CarouselProps> {}

export const AppCarousel = memo(function AppCarousel({...rest}: Props) {
  return <Carousel {...rest}></Carousel>;
});
